import type { CharacterDraft } from '../stores/types';

/**
 * Check if a character draft contains any meaningful data beyond defaults.
 * Used to determine if there's an "in-progress" character worth resuming.
 */
export function hasCharacterData(draft: CharacterDraft): boolean {
  return (
    draft.name.trim() !== '' ||
    draft.raceId !== null ||
    draft.classId !== null ||
    draft.backgroundId !== null ||
    draft.confirmedCommoner ||
    Object.values(draft.abilityScores).some((score) => score !== 8)
  );
}
